import { useState } from 'react'

export const useForm = (initState = {}) => {
  
    const [values, setValues] = useState(initState)

    const handleInputChange = ({ target }) => {
        setValues({
            ...values,
            [ target.name ]: target.value
        })
    }

    const reset = (newFormValues = initState) => {
        setValues(newFormValues)
    }

    return [ values, handleInputChange, reset ]
}